import Vue from 'vue';
import {
  GET_INTERACTIONS_FOR_SLIDE,
  GET_TASK_FOR_GROUP,
  SLIDE_GET_TREE,
  SLIDES_GET_CURRENT
} from '@/config/constants';

export default Vue.extend({
  data() {
    return {
      openLayer: false
    };
  },
  watch: {
    '$route.query': function(o: any, i: any) {
      if (o.asset) {
        // @ts-ignore
        this.openLayer = true;
      } else {
        // @ts-ignore
        this.openLayer = false;
      }
    }
  },
  created() {
    this.openLayer = !!this.$route.query.asset;
  },
  methods: {
    async getData(forId: string): Promise<any> {
      // Performance tes
      await this.getSlide(forId);
      this.getTasksByGroup(forId);
      this.getInteractions();
      this.getTree();
    },
    getSlide(id: string): any {
      // @ts-ignore
      return this.$store.dispatch(SLIDES_GET_CURRENT, id);
    },
    getTasksByGroup(id: string): any {
      if (!id) return;
      // @ts-ignore
      return this.$store.dispatch(GET_TASK_FOR_GROUP, id);
    },
    getTree(): any {
      // @ts-ignore
      return this.$store.dispatch(SLIDE_GET_TREE);
    },
    getInteractions(): any {
      // @ts-ignore
      return this.$store.dispatch(GET_INTERACTIONS_FOR_SLIDE);
    }
  }
});
